module.exports = __webpack_public_path__ + "static/landing-image-03-2fbce745d411e9fe4d0e613aa66ea8f6.png";